import React, { useState } from "react";
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import DisplayImage from "../DisplayImage";
import { MdDelete } from "react-icons/md";
import { v4 as uuidv4 } from "uuid";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { toast } from "react-toastify";
import "../../css/Admin-Courses/AdminEditCourses.css";
import Spinner from "../Spinner";

const AdminEditCourses = ({ onClose, productData, fetchData, projectKey }) => {
  const [uploadCourseLogo, setUploadCourseLogo] = useState(0);
  const [uploadCourseCertificates, setUploadCourseCertificates] =
    useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    ...productData,
    courseName: productData?.courseName,
    courseInstitute: productData?.courseInstitute,
    courseYear: productData?.courseYear,
    courseLogo: productData?.courseLogo || [],
    courseCertificates: productData?.courseCertificates || [],
  });

  const [fullScreenImage, setFullScreenImage] = useState("");
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };

  async function handleUploadLogo(e) {
    setLoading(true);
    const image = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `${data?.courseName}-${image.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Handle state changes such as progress, pause, and resume
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          setUploadCourseLogo(progress);
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          reject(error);
          setLoading(false);
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              courseLogo: [...prev.courseLogo, downloadURL],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  async function handleUploadCertificates(e) {
    setLoading(true);
    const video = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `${data?.courseName}-${video.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, video);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Image Upload is " + progress + "% done");
          setUploadCourseCertificates(progress);
        },
        (error) => {
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              courseCertificates: [
                ...(prev.courseCertificates || []),
                downloadURL,
              ],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  const handleDeleteLogo = (index) => {
    //console.log("clicl");
    const newLogos = [...data.courseLogo];
    newLogos.splice(index, 1);
    setData((pre) => {
      return {
        ...pre,
        courseLogo: [...newLogos],
      };
    });
  };

  const handleDeleteCertificates = (index) => {
    const newCertificates = [...data.courseCertificates];
    newCertificates.splice(index, 1);
    setData((pre) => ({
      ...pre,
      courseCertificates: newCertificates,
    }));
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    //console.log(projectKey);
    const docRef = doc(db, "courses", projectKey);
    await updateDoc(docRef, data);
    setLoading(false);
    toast.success("Course Updated");
    fetchData();
    onClose();
  };
  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="overlay">
      <div className="edit-product-modal">
        <div className="modal-header">
          <h2 className="title">Edit course</h2>
          <div className="close-icon" onClick={onClose}>
            <CgClose />
          </div>
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <label htmlFor="courseName">Course Name :</label>
          <input
            type="text"
            id="courseName"
            placeholder="Enter Course name"
            value={data.courseName}
            name="courseName"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="courseInstitute">Institute Name :</label>
          <input
            type="text"
            id="courseInstitute"
            placeholder="Enter Institute Name"
            value={data.courseInstitute}
            name="courseInstitute"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="courseYear">Year :</label>
          <input
            type="text"
            className="input"
            placeholder="Enter the Year"
            value={data.courseYear}
            name="courseYear"
            onChange={handleOnChange}
          />
          <label htmlFor="courseLogo" className="label">
          Course Logo :
          </label>
          <label htmlFor="courseLogo">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Course Logo</p>
                <input
                  type="file"
                  id="courseLogo"
                  className="hidden"
                  onChange={handleUploadLogo}
                />
              </div>
            </div>
          </label>
          {uploadCourseLogo > 0 && uploadCourseLogo < 100 && (
            <label
              style={{ color: "blue", textAlign: "center" }}
            >{`Upload is ${uploadCourseLogo}% done`}</label>
          )}

          <div>
            {data.courseLogo.length > 0 ? (
              <div className="image-preview">
                {data.courseLogo.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteLogo(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">*Please Upload Course Logo</p>
            )}
          </div>

          <label htmlFor="courseCertificates" className="label">
            Certificates:
          </label>
          <label htmlFor="courseCertificates">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Certificates</p>
                <input
                  type="file"
                  id="courseCertificates"
                  className="hidden"
                  onChange={handleUploadCertificates}
                />
              </div>
            </div>
          </label>
          {uploadCourseCertificates > 0 &&
            uploadCourseCertificates < 100 && (
              <label
                style={{ color: "blue", textAlign: "center" }}
              >{`Upload is ${uploadCourseCertificates}% done`}</label>
            )}

          <div>
            {data.courseCertificates.length > 0 ? (
              <div className="image-preview">
                {data.courseCertificates.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteCertificates(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">
                *Please Upload Course Certificates
              </p>
            )}
          </div>
          <button className="submit-button">Update Course</button>
        </form>
      </div>
      {openFullScreenImage && (
        <DisplayImage
          onClose={() => setOpenFullScreenImage(false)}
          imageUrl={fullScreenImage}
        />
      )}
    </div>
  );
};

export default AdminEditCourses;
